import React from 'react';

class Message extends React.Component {
    render() {
        return <div className={this.props.type + ' padding-bottom-20'}>{this.props.error}</div>;
    }
}

export default Message;